import moment, { Moment } from "moment";
import { titleize } from "underscore.string";

import { EarningByRegion, Source } from "services/valuation/types";

import { earningSourceNameToDisplayName } from "./constants";

function translateName(
  n: string,
  translationMap: { [k: string]: string },
): string {
  if (n in translationMap) {
    return translationMap[n];
  }
  // The default translation for Source is capitalization (e.g.: 'SATELLITE RADIO' -> 'Satellite Radio')
  // If it is not enough, the explicit translation should be specified in backendSourceNameToFullName
  return titleize(n);
}

export function translateSourceName(n: string) {
  return translateName(n, earningSourceNameToDisplayName);
}

export function formatValuationReportData(reportData: Source[]): Source[] {
  return reportData.every(s => !!s.earning_details)
    ? reportData.map(s => ({
        ...s,
        name: translateSourceName(s.name),
        earning_details: s.earning_details.map(d => ({
          ...d,
          name: translateSourceName(d.name),
        })),
      }))
    : reportData.map(s => ({
        ...s,
        name: translateSourceName(s.name),
      }));
}

export function getReportOnTopSongs(
  topSongs: {
    name: string;
    earnings: number;
  }[],
): { name: string; earnings: number }[] {
  return topSongs.map(s => ({
    ...s,
    name: titleize(s.name),
  }));
}

export function getReportTotalEarnings(source: Source[]) {
  return source.reduce((acc, val) => acc + Math.abs(val.earnings), 0) || 0;
}

export function parseChartDataIntoTuples(
  earningsByQuarter: [string, EarningByRegion | number][],
): {
  date: Moment;
  amount: number | EarningByRegion;
}[] {
  return earningsByQuarter.map(z => ({
    date: moment(z[0]),
    amount: z[1],
  }));
}
